import { noop } from 'lodash-es';
import React from 'react';
import ReactDom from 'react-dom';
import { VISUALIZATION_API_HOST, getSystemUser, getAppConfig } from '../../../api';
import store from '../../../store';
import Plugin from './index';

// 预先发起woa请求进行登录
const preLogin = () => new Promise((resolve) => {
  if (window.location.host === VISUALIZATION_API_HOST) {
    resolve(true);
    return;
  }
  const div = document.createElement('div');
  div.setAttribute('id', 'drhPreLogin');
  ReactDom.render(
    <iframe src={`https://${VISUALIZATION_API_HOST}/data-report-hub/pre-login`} width={0} height={0} onLoad={() => {
      document.querySelector('#drhPreLogin')?.remove();
      resolve(true);
    }} />,
    document.body.appendChild(div),
  );
});

class VisualizationPlugin extends Plugin {
  name = 'visualization';
  private inited = false;
  private $destroyVisualization = noop;
  private $initVisualization = noop;

  init() {
    const { enableVisualization } = store.config;
    if (enableVisualization) {
      // 初始化可视化
      window.addEventListener('load', () => {
        this.setEnable(true);
      });
    }
  }

  // 设置可视化
  public setEnable(enable: boolean) {
    const { enableVisualization } = store.config;
    if (enable) { // 开启可视化
      // 初始化可视化资源
      if (!this.inited) {
        this.initVisualization();
        return;
      }
      // 设置开启可视化
      if (!enableVisualization) {
        this.$initVisualization(this.instance);
      }
    } else if (enableVisualization) { // 关闭可视化
      this.$destroyVisualization();
    }
    store.setConfig({ enableVisualization: enable });
  }

  private initVisualization() {
    preLogin().then(() => {
      getSystemUser().then((res: any) => {
        // 设置内部员工姓名
        if (res?.system?.user?.name) {
          store.setStaffname(res.system.user.name);
        }
        if (!res?.system?.user?.allow) return;
        import('../../visualization/').then(({ initVisualization, destroyVisualization }) => {
          initVisualization(this.instance);
          this.inited = true;
          this.$initVisualization = initVisualization;
          this.$destroyVisualization = destroyVisualization;
          store.setConfig({ enableVisualization: true });
        });
      })
        .catch(err => console.warn(`data repot hub visualization init fail: ${err.message}`));

      // 拉取筛选配置
      getAppConfig().then((res: any) => {
        store.setFilterConfig(res?.app_config?.filter_config || []);
        store.setAppConfig(res?.app_config?.other_config || {});
      })
        .catch(() => { });
    });
  };
}

export default VisualizationPlugin;
